import { COLORS } from '../../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => {
  // take mobile-first approach to do the styling

  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');
  // const minLg = theme.breakpoints.up('lg');
  // const minXl = theme.breakpoints.up('xl');

  return {
    tableWrapper: {
      [minSm]: {
        // 200 is the width of the sidebar, 60 is the left padding and right padding of the main container
        width: 'calc(100vw - 200px - 60px)',
      },
      [minMd]: {
        width: '100%',
      },
      '& > div': {
        borderRight: `1px solid ${COLORS.GREY}`,
      },
      '& table': {
        borderBottom: `1px solid ${COLORS.GREY}`,
      },
      '& table tbody tr td div': {
        backgroundColor: COLORS.WHITE_DARK,
      },
      '& table tbody tr td:last-child': {
        paddingLeft: 25,
        paddingRight: 25,
      },
      '& table tbody tr td:first-child': {
        height: 58,

        '& > div': {
          height: '100%',
        },
      },
    },
  };
};

export default styles;
